import { Component, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, forkJoin } from 'rxjs';
import { WorldCreditsModalPurchaseComponent } from '../../player/modals/ai-generation/world-credits-modal-purchase/world-credits-modal.component';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { AiPortraitTokenService } from '../../player/modals/ai-generation/service/ai-portrait-token.service';
import { TokenBalanceResponse } from '../../player/modals/ai-generation/model/ai-generate-image-response.model';
import { TokenCreditTransactionResponse, TokenPack } from './model/token-credit.model';
import { Router } from '@angular/router';
import { SubscriptionService } from '../../subscription/services/subscription.service';

@Component({
    selector: 'app-token-credit-modal',
    templateUrl: './token-credit-modal.component.html',
    styleUrls: ['./token-credit-modal.component.scss'],
    standalone: false
})
export class TokenCreditModalComponent {
  transactions: TokenCreditTransactionResponse;
  tokenBalance: TokenBalanceResponse;
  isLoading: boolean = false;
  tokenPacks: TokenPack[] = [];
  currentUserSubscription: Subscription;
  userId: number | string | any;

  get history() {
    return this.transactions?.results || [];
  }

  get monthly(): number {
    return this.tokenBalance?.breakdown?.monthly_recurring || 0;
  }

  get bonus(): number {
    return this.tokenBalance?.breakdown?.bonus || 0;
  }

  get worldCredits(): number {
    return this.tokenBalance?.breakdown?.world_credits || 0;
  }

  formatDelta(value: number | null | undefined): string {
    if (value === 0 || value == null) return '—';
    return value > 0 ? `+${value}` : `${value}`;
  }

  constructor(public activeModal: NgbActiveModal,
    private aiPortraitTokenService: AiPortraitTokenService,
    private subscriptionService: SubscriptionService,
    private currentUserService: CurrentUserService,
    private modalService: NgbModal,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  close() {
    this.activeModal.close();
  }

  ngOnInit(): void {
    this.currentUserSubscription = this.currentUserService.currentUser.subscribe((res) => {
        if(res && res.id){
            this.userId = res.id;
            this.getTokenTransaction();
        }
    
          this.cdr.detectChanges();});
  }

  getTokenTransaction() {
    this.isLoading = true;
    // Packs come from the app's own token store (api/tokens/token-packs/),
    // not the WordPress shop — the same packs and Stripe Checkout the
    // AI-restock and world-credit windows use, crediting the same wallet.
    forkJoin({
      transactions: this.aiPortraitTokenService.getTokenTransaction(this.userId),
      balance: this.aiPortraitTokenService.getTokenBalance(this.userId),
      productsResponse: this.subscriptionService.getStripeProducts()
    }).subscribe({
      next: (res: {
        transactions: TokenCreditTransactionResponse,
        balance: TokenBalanceResponse,
        productsResponse: { token_packs: TokenPack[] }
      }) => {
        this.transactions = res.transactions;
        this.tokenBalance = res.balance;
        this.tokenPacks = (res.productsResponse.token_packs || [])
          .map((pack) => ({ ...pack, image: pack.image || this.packImage(pack) }))
          .sort((a, b) => Number(a.price) - Number(b.price));

        this.isLoading = false;
        this.cdr.detectChanges();
      },


      error: () => {
        this.isLoading = false;

          this.cdr.detectChanges();}
    });
  }

  isWorldCredit(pack: TokenPack): boolean {
    return pack.pack_type === 'wcredit';
  }

  /** Card art (bundled — it used to come from the WordPress shop). */
  private packImage(pack: TokenPack): string {
    if (this.isWorldCredit(pack)) return 'assets/images/token-packs/world-credit.jpg';
    return Number(pack.tokens) >= 500
      ? 'assets/images/token-packs/master.jpg'
      : 'assets/images/token-packs/initiate.jpg';
  }

  buyingPackId: number | null = null;

  /** Opens Stripe Checkout; Stripe returns to the app and the wallet is credited by webhook. */
  buyProduct(pack: TokenPack) {
    if (this.buyingPackId) return;
    this.buyingPackId = pack.id;
    this.subscriptionService.createTokenPackCheckoutSession(this.userId, pack.id).subscribe({
      next: (res) => {
        if (res?.checkout_url) {
          window.location.href = res.checkout_url;
          return;
        }
        this.buyingPackId = null;
        this.cdr.detectChanges();
      },
      error: () => {
        this.buyingPackId = null;
        this.cdr.detectChanges();
      },
    });
  }

  intializeWorldCreditModal() {
    if (this.tokenBalance.breakdown.world_credits <= 0) {
      const modalRef = this.modalService.open(WorldCreditsModalPurchaseComponent, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
        windowClass: 'ai-token-modal'
      });
    }
    else {
      this.activeModal.close();
      this.router.navigate(['/subscription']);
    }
  }
}
